import {
  ApiOutlined,
  ExclamationCircleOutlined,
  InboxOutlined,
  LockOutlined,
} from '@ant-design/icons';
import { Card, Result } from 'antd';
import { useTranslation } from 'react-i18next';

import { VansBlockedReason } from '../types';

const I18N_BASE = 'scenes.vans.components.blocked_state';

const ICON_BY_REASON: Record<VansBlockedReason, JSX.Element> = {
  integration_disabled: <ApiOutlined />,
  company_required: <ExclamationCircleOutlined />,
  scope_not_configured: <LockOutlined />,
  no_distributors: <InboxOutlined />,
  generic: <ExclamationCircleOutlined />,
};

interface VansBlockedStateProps {
  reason: VansBlockedReason;
}

/**
 * Cada motivo se arregla en un lugar distinto —dos en Compañías, uno en Roles—,
 * así que cada uno dice qué pasa y dónde resolverlo en vez de un vacío genérico.
 */
function VansBlockedState({ reason }: VansBlockedStateProps) {
  const { t } = useTranslation();

  return (
    <Card style={{ marginTop: '12px' }}>
      <Result
        icon={
          <span className="vans-blocked__icon">{ICON_BY_REASON[reason]}</span>
        }
        title={t(`${I18N_BASE}.${reason}.title`)}
        subTitle={
          <span className="vans-blocked__subtitle">
            <span>{t(`${I18N_BASE}.${reason}.description`)}</span>
            <span className="vans-blocked__hint">
              {t(`${I18N_BASE}.${reason}.hint`)}
            </span>
          </span>
        }
      />
    </Card>
  );
}

export default VansBlockedState;
